const autentificacion = require('../modulosChatBox/autentificacion');
const seguimiento = require('../modulosChatBox/seguimiento');
const rehabilitacion = require('../modulosChatBox/rehabilitacion');
const gestion = require('../modulosChatBox/gestion');
const listas = require('../modulosChatBox/listas');
const agendas = require('../modulosChatBox/agendas');
const formularios = require('../modulosChatBox/formularios');
const cie10 = require('../modulosChatBox/cie10');
const modelo = require('../modulosChatBox/modelo');
const login = require('../modulosChatBox/login');
const administradorUsuarios = require('../modulosChatBox/administradorUsuarios');
const eventos = require('../modulosChatBox/eventos');
const preguntas = require('../modulosChatBox/preguntas');
const ordenes = require('../modulosChatBox/ordenes');
const verEncuentros = require('../modulosChatBox/verEncuentros');
const recepcion = require('../modulosChatBox/recepcion');
const agendamiento = require('../modulosChatBox/agendamiento');


module.exports.enrutadorChatBox = function enrutadorChatBox(action, response) {
  return new Promise((resolve, reject) => {
    switch (action.substring(3, 6)) {
      case 'aut':
        autentificacion.autentificacionEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'seg':
        seguimiento.seguimientoEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'rhb':
        rehabilitacion.rehabilitacionEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'lis':
        listas.listasEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'gtn':
        gestion.gestionEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'vag':
        agendas.agendasEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'for':
        formularios.formulariosEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'cie':
        cie10.cie10Estados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'mod':
        modelo.modeloEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'log':
        login.loginEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'usu':
        administradorUsuarios.administradorUsuariosEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'eve':
        eventos.eventosEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'pyr':
        preguntas.preguntasEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'ord':
        ordenes.ordenesEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'vec':
        verEncuentros.verEncuentrosEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'rcp':
        recepcion.recepcionEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      case 'age':
        agendamiento.agendamientoEstados(action, response)
          .then(([matrizActionValor, valorCambiaPanelLateral]) => {
            resolve(([matrizActionValor, valorCambiaPanelLateral]));
          });
        break;
      default:
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('Error');
        break;
    }
  });
};



// WEBPACK FOOTER //
// ./src/js/componentes/CChatBox.js